import * as React from 'react';
import MobileStepper from '@mui/material/MobileStepper';
import Typography from '@mui/material/Typography';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import { Layout } from 'src/styles';
import { FormWizard } from 'src/@types';
import { appDispatch } from 'src/utils/utils';
import { setsubmitSuccessTarget } from 'src/features/pageSlice';

import AsmubipButton from './AsmubipButton';

export default function FormStepper({
  pages,
  submitSuccessTarget,
  isValid,
  page,
}: FormWizard & { isValid?: boolean; page: number }) {
  const handleNext = () => {
    if (!isValid) {
      return;
    }
    // Finished!
    if (page === pages) {
      appDispatch(setsubmitSuccessTarget(submitSuccessTarget));
      return;
    }

    const newPage = page + 1;
    const newTarget = location.pathname.includes('/create')
      ? `${location.pathname.replace('/create', '/edit/{ID}')}?page=${newPage}`
      : `${location.pathname}?page=${newPage}`;
    appDispatch(setsubmitSuccessTarget(newTarget));
  };

  const handleBack = () => {
    if (page === 1) {
      return;
    }
    const newPage = page - 1;
    const newTarget = `${location.pathname}?page=${newPage}`;
    appDispatch(setsubmitSuccessTarget(newTarget));
  };

  return (
    <>
      {/* <MobileStepper sx={Layout.auxiliarMobileStepper}
      variant="text"
      backButton={null}
      nextButton={null}
      steps={steps}
      activeStep={step+1}
      position='bottom'
    ></MobileStepper> */}

      <Typography sx={Layout.stepNumbers}>
        {page}/{pages}
      </Typography>

      <MobileStepper
        variant="progress"
        steps={pages + 1}
        position="bottom"
        activeStep={page}
        sx={Layout.mobileStepper}
        nextButton={
          <AsmubipButton
            variant="contained-bottom-bar"
            sx={{ gridColumn: '3' }}
            size="small"
            type="submit"
            onClick={handleNext}>
            {page === pages ? 'Finalizar' : 'Próximo'}
            <KeyboardArrowRight />
          </AsmubipButton>
        }
        backButton={
          page > 1 ? (
            <AsmubipButton
              variant="contained-bottom-bar"
              size="small"
              type="submit"
              onClick={handleBack}>
              <KeyboardArrowLeft />
              Voltar
            </AsmubipButton>
          ) : null
        }
      />
    </>
  );
}
